import React, { useContext, useEffect, useRef, useState } from "react";
import { TMDataContext } from "../../../utils/custom_hooks/TMDataContext";
import { Measurement } from "../../classes/measurements/measurement";
import { InterviewFormContext } from "../../hooks/InterviewFormContext";
import { AchievementTargetInputPropsShape } from "../../interfaces/componentTypes";
import { NumericInput } from "./generalUtilities";

export const AchievementTargetInput: React.FC<AchievementTargetInputPropsShape> = ({
  achievementTarget,
  handleAchievementTarget,
  measurementUnit,
  measurementId,
  approved,
}) => {
  const { t } = useContext(TMDataContext);
  const [formattedValue, setFormattedValue] = useState<number | null>(
    achievementTarget
  );

  const measurementDecimalPlaces = () => {
    if (!Measurement.findById(measurementId)) return 0;
    return Measurement.findById(measurementId).decimalplaces;
  };

  let activeId = "goal-target-value-input";

  const checkDecimals = (value) => {
    let inputScreen;

    switch (measurementDecimalPlaces()) {
      case 0:
        inputScreen = new RegExp(/^\d*(\d)?$/);
        break;
      case 1:
        inputScreen = new RegExp(/^\d*(\.\d{0,1})?$/);
        break;
      case 2:
        inputScreen = new RegExp(/^\d*(\.\d{0,2})?$/);
        break;

      default:
        inputScreen = new RegExp(/^\d*(\d)?$/);
        break;
    }
    return !!inputScreen.exec(value);
  };

  const processInputValue = (value) => {
    if (checkDecimals(value)) {
      setFormattedValue(value);
    }
  };

  useEffect(() => {
    handleAchievementTarget(formattedValue);
  }, [formattedValue]);

  return (
    <div
      className="goal-boxed-input-area"
      style={{ display: `${approved ? "block" : "none"}` }}
    >
      <div className="goal-form-input-row">
        <label className="goal-input-area-title" htmlFor={activeId}>
          {t("views.goals.headings.goal_target")}
        </label>
        <NumericInput
          id={activeId}
          handleValue={processInputValue}
          state={achievementTarget == null ? "" : achievementTarget}
        />
        <span style={{ marginLeft: "10px", marginRight: "10px" }}>
          {measurementUnit}
        </span>
      </div>
    </div>
  );
};
